import "./HighlightCard.css";

export default function HighlightCard({ title, text }) {
  return (
    <div className="highlight-card">
      <div className="highlight-card__square" />
      <div className="highlight-card__content">
        <div className="highlight-card__title">{title}</div>
        <div className="highlight-card__text">{text}</div>
      </div>
    </div>
  );
};